var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-pause"},[_vm._v(" Kurze Pause ")])
}
var staticRenderFns = []

export { render, staticRenderFns }